<template>
  <div>
    <h1 class="mdn-Heading mdn-Heading--sm">Importar Tickets em Lote</h1>

    <v-tabs v-model="abaAtiva" class="mb-4">
      <v-tab>Importar</v-tab>
      <v-tab>Histórico</v-tab>
    </v-tabs>

    <v-tabs-items v-model="abaAtiva">
      <!-- ABA IMPORTAR -->
      <v-tab-item>
        <v-card flat>
          <v-card-text>

            <template v-if="etapa === 'upload'">
              <p class="text-center mb-4" style="color: #555;">
                Realize a importação de tickets através de planilha padrão
              </p>

              <div class="d-flex justify-content-center gap-3 mb-4">
                <v-btn outlined color="primary" small @click="baixarModelo" :loading="baixandoModelo">
                  <v-icon left small>mdi-download</v-icon>
                  Baixar modelo
                </v-btn>

                <v-btn color="primary" small @click="$refs.fileInput.click()" :loading="importando">
                  <v-icon left small>mdi-upload</v-icon>
                  Selecionar arquivo
                </v-btn>
              </div>

              <input
                ref="fileInput"
                type="file"
                accept=".xlsx,.csv"
                style="display: none"
                @change="selecionarArquivo"
              />

              <div
                class="drop-zone"
                :class="{ 'drop-zone--over': arrastando }"
                @dragover.prevent="arrastando = true"
                @dragleave.prevent="arrastando = false"
                @drop.prevent="onDrop"
                @click="$refs.fileInput.click()"
              >
                <v-icon large color="grey">mdi-cloud-upload-outline</v-icon>
                <p class="mb-1 mt-2" style="font-size: 13px; color: #777;">
                  Arraste o arquivo aqui ou clique para selecionar
                </p>
                <p v-if="arquivoSelecionado" class="mb-0 font-weight-medium" style="font-size: 13px; color: #333;">
                  {{ arquivoSelecionado.name }}
                </p>
              </div>

              <p class="text-center mt-2 mb-0" style="font-size: 11px; color: #999;">
                Formatos aceitos: XLSX, CSV &nbsp;|&nbsp; Tamanho máximo: 5MB
              </p>

              <p v-if="erroUpload" class="text-center mt-2 mb-0 red--text" style="font-size: 12px;">
                {{ erroUpload }}
              </p>

              <div v-if="arquivoSelecionado" class="d-flex justify-content-center mt-4">
                <v-btn color="success" small @click="enviarArquivo" :loading="importando">
                  Confirmar importação
                </v-btn>
              </div>
            </template>

            <template v-else-if="etapa === 'aguardando'">
              <div class="text-center py-6">
                <v-progress-circular indeterminate color="primary" size="48" class="mb-3" />
                <p class="mb-0" style="color: #555;">Processando importação, aguarde...</p>
              </div>
            </template>

            <template v-else-if="etapa === 'concluido'">
              <div class="text-center mb-4">
                <v-icon color="success" size="48">mdi-check-circle-outline</v-icon>
                <p class="mt-2 mb-1 font-weight-medium" style="font-size: 16px;">Importação concluída</p>
              </div>

              <v-row class="mb-4" justify="center">
                <v-col cols="auto">
                  <v-chip color="success" text-color="white">
                    <v-icon left small>mdi-check</v-icon>
                    {{ statusImportacao.success_rows }} criado(s) com sucesso
                  </v-chip>
                </v-col>
                <v-col cols="auto" v-if="totalRejeitados > 0">
                  <v-chip color="error" text-color="white">
                    <v-icon left small>mdi-close</v-icon>
                    {{ totalRejeitados }} rejeitado(s)
                  </v-chip>
                </v-col>
              </v-row>

              <template v-if="statusImportacao.errors && statusImportacao.errors.length">
                <v-divider class="mb-3" />
                <p class="mb-2 font-weight-medium" style="font-size: 13px; color: #c62828;">
                  Registros com erro:
                </p>
                <v-simple-table dense>
                  <template #default>
                    <thead>
                      <tr>
                        <th>Linha</th>
                        <th>Campo</th>
                        <th>Motivo</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(erro, i) in statusImportacao.errors"
                        :key="i"
                        :class="{ 'red lighten-5': erro.campo === 'Número REC' && erro.mensagem.includes('duplicada') }"
                      >
                        <td>{{ erro.linha }}</td>
                        <td>
                          {{ erro.campo }}
                          <v-chip
                            v-if="erro.campo === 'Número REC' && erro.mensagem.includes('duplicada')"
                            x-small color="warning" text-color="white" class="ml-1"
                          >
                            REC duplicada
                          </v-chip>
                        </td>
                        <td>{{ erro.mensagem }}</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
              </template>

              <div class="d-flex justify-content-center mt-5" style="gap: 12px;">
                <v-btn outlined small @click="reiniciar">Nova importação</v-btn>
                <v-btn color="primary" small @click="irParaHistorico">Ver histórico</v-btn>
              </div>
            </template>

            <template v-else-if="etapa === 'erro'">
              <div class="text-center py-6">
                <v-icon color="error" size="48">mdi-alert-circle-outline</v-icon>
                <p class="mt-2 mb-1 font-weight-medium red--text">Falha na importação</p>
                <p style="font-size: 13px; color: #555;">{{ mensagemErro }}</p>
                <v-btn outlined small class="mt-3" @click="reiniciar">Tentar novamente</v-btn>
              </div>
            </template>

          </v-card-text>
        </v-card>
      </v-tab-item>

      <!-- ABA HISTÓRICO -->
      <v-tab-item>
        <v-card flat>
          <v-card-text>
            <div class="d-flex justify-end mb-3">
              <v-btn small outlined @click="carregarHistorico" :loading="carregandoHistorico">
                <v-icon left small>mdi-refresh</v-icon>
                Atualizar
              </v-btn>
            </div>

            <v-data-table
              :headers="headersHistorico"
              :items="historico"
              :loading="carregandoHistorico"
              no-data-text="Nenhuma importação encontrada"
              loading-text="Carregando histórico..."
              dense
            >
              <template #item.created_at="{ item }">
                {{ formatarData(item.created_at) }}
              </template>
              <template #item.status="{ item }">
                <v-chip x-small :color="corStatus(item.status)" text-color="white">
                  {{ labelStatus(item.status) }}
                </v-chip>
              </template>
              <template #item.success_rows="{ item }">
                {{ item.success_rows }} / {{ item.total_rows }}
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  name: 'ImportarTicketsLotePage',

  data() {
    return {
      abaAtiva: 0,
      etapa: 'upload',
      arrastando: false,
      arquivoSelecionado: null,
      erroUpload: null,
      importando: false,
      baixandoModelo: false,
      mensagemErro: '',
      statusImportacao: {},
      pollingInterval: null,
      historico: [],
      carregandoHistorico: false,
      headersHistorico: [
        { text: 'Data / Hora', value: 'created_at', sortable: false },
        { text: 'Tickets criados', value: 'success_rows', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
      ],
    };
  },

  computed: {
    totalRejeitados() {
      return (this.statusImportacao.total_rows || 0) - (this.statusImportacao.success_rows || 0);
    },
  },

  watch: {
    abaAtiva(val) {
      if (val === 1) this.carregarHistorico();
    },
  },

  beforeDestroy() {
    this.pararPolling();
  },

  methods: {
    ...mapActions('tickets', [
      'importarTickets',
      'verificarStatusImportacaoTicket',
      'baixarModeloImportacaoTicket',
      'buscarHistoricoImportacoes',
    ]),

    selecionarArquivo(event) {
      const arquivo = event.target.files[0];
      if (arquivo) this.validarEDefinirArquivo(arquivo);
      event.target.value = '';
    },

    onDrop(event) {
      this.arrastando = false;
      const arquivo = event.dataTransfer.files[0];
      if (arquivo) this.validarEDefinirArquivo(arquivo);
    },

    validarEDefinirArquivo(arquivo) {
      this.erroUpload = null;
      const extensao = arquivo.name.split('.').pop().toLowerCase();

      if (!['xlsx', 'csv'].includes(extensao)) {
        this.erroUpload = 'Formato inválido. Use XLSX ou CSV.';
        return;
      }

      if (arquivo.size > 5 * 1024 * 1024) {
        this.erroUpload = 'O arquivo excede o limite de 5MB.';
        return;
      }

      this.arquivoSelecionado = arquivo;
    },

    async enviarArquivo() {
      if (!this.arquivoSelecionado) return;

      this.importando = true;
      this.erroUpload = null;

      try {
        const formData = new FormData();
        formData.append('arquivo', this.arquivoSelecionado);

        const response = await this.importarTickets(formData);
        const jobId = response?.data?.data?.job_id;

        if (!jobId) throw new Error('Resposta inválida do servidor.');

        this.etapa = 'aguardando';
        this.iniciarPolling(jobId);
      } catch (error) {
        const mensagem = error?.response?.data?.message || error?.message || 'Erro ao enviar arquivo.';
        this.erroUpload = mensagem;
      } finally {
        this.importando = false;
      }
    },

    iniciarPolling(jobId) {
      this.pollingInterval = setInterval(async () => {
        try {
          const response = await this.verificarStatusImportacaoTicket(jobId);
          const status = response?.data?.data;

          if (!status) return;

          const statusFinais = ['completed', 'completed_with_errors', 'failed'];
          if (statusFinais.includes(status.status)) {
            this.pararPolling();
            this.statusImportacao = status;

            if (status.status === 'failed') {
              const primeiro = status.errors?.[0];
              this.mensagemErro = primeiro?.mensagem || 'Erro desconhecido durante a importação.';
              this.etapa = 'erro';
            } else {
              this.etapa = 'concluido';
            }
          }
        } catch {
          this.pararPolling();
          this.mensagemErro = 'Erro ao verificar status da importação.';
          this.etapa = 'erro';
        }
      }, 3000);
    },

    pararPolling() {
      if (this.pollingInterval) {
        clearInterval(this.pollingInterval);
        this.pollingInterval = null;
      }
    },

    async baixarModelo() {
      this.baixandoModelo = true;
      try {
        await this.baixarModeloImportacaoTicket();
      } finally {
        this.baixandoModelo = false;
      }
    },

    reiniciar() {
      this.etapa = 'upload';
      this.arquivoSelecionado = null;
      this.erroUpload = null;
      this.statusImportacao = {};
      this.mensagemErro = '';
    },

    irParaHistorico() {
      this.abaAtiva = 1;
    },

    async carregarHistorico() {
      this.carregandoHistorico = true;
      try {
        const response = await this.buscarHistoricoImportacoes();
        this.historico = response?.data?.data || [];
      } catch {
        this.historico = [];
      } finally {
        this.carregandoHistorico = false;
      }
    },

    formatarData(dataStr) {
      if (!dataStr) return '-';
      const data = new Date(dataStr);
      return data.toLocaleString('pt-BR');
    },

    corStatus(status) {
      const cores = {
        completed: 'success',
        completed_with_errors: 'warning',
        failed: 'error',
        processing: 'primary',
        pending: 'grey',
      };
      return cores[status] || 'grey';
    },

    labelStatus(status) {
      const labels = {
        completed: 'Concluído',
        completed_with_errors: 'Concluído c/ erros',
        failed: 'Falhou',
        processing: 'Processando',
        pending: 'Aguardando',
      };
      return labels[status] || status;
    },
  },
};
</script>

<style scoped>
.drop-zone {
  border: 2px dashed #ccc;
  border-radius: 8px;
  padding: 32px 16px;
  text-align: center;
  cursor: pointer;
  transition: border-color 0.2s, background 0.2s;
  max-width: 480px;
  margin: 0 auto;
}

.drop-zone:hover,
.drop-zone--over {
  border-color: #1976d2;
  background: #f0f7ff;
}
</style>